'use client';

import React from 'react';
import MainLayout from '@layout/MainLayout';
import Link from 'next/link';
import ErrorPageTracker from '../../../../ErrorPageTracker';

export default function Error({ error, reset }) {
  return (
    <MainLayout>
      <ErrorPageTracker error={error} boundary="servicio" />
      <div className="container">
        <div className="text-center py-16">
          <h1 className="text-2xl font-bold text-[#1a1a1a] mb-3">Algo salió mal</h1>
          <p className="text-[15px] text-gray-500 mb-8">No pudimos cargar este servicio. Probá de nuevo en unos segundos.</p>
          <button
            className="px-6 py-2.5 rounded-xl bg-primary-500 text-white text-sm font-medium hover:bg-primary-600 transition-colors"
            onClick={() => reset()}
          >
            Intentar de nuevo
          </button>
          <Link href="/" className="block mt-4 text-sm text-primary-600 hover:underline">
            Volver al inicio
          </Link>
        </div>
      </div>
    </MainLayout>
  );
}
